import React, { useEffect, useState } from 'react'
import Wrapper from '../components/Wrapper.js'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Api from '../Api.js'
import Loader from '../components/BlueButton/Loader.js'
import { Col, Row } from 'react-bootstrap'
import { TextField } from '@mui/material'
import moment from 'moment'
import { word } from '../word.js'
import AgentFiles from '../components/Agents/AgentFiles.js'
import BlueButton from '../components/BlueButton/BlueButton.js'
import FileUpload from '../components/Agents/FileUpload.js'
import { useDispatch, useSelector } from 'react-redux'
import { useTaskTime } from '../components/Agents/timerHelper.js'
import { agentTimer } from '../store/actions/agent.js'
import LittleButton from '../components/BlueButton/LittleButton.js'
import AgentComment from '../components/Agents/AgentComment.js'
import MessageInput from '../components/Agents/MessageInput.js'
import SuccessToast from '../components/BlueButton/SuccessToast.js'
export default function AgentSingle() {
  let profession = localStorage.getItem("profession")
  const login = useSelector((state) => state.manager.employee);
  const location = useLocation()
  const { id } = useParams()
  const [single, setSingle] = useState(null)
  const [timers, setTimers] = useState([])
  const dispatch = useDispatch()
  const [visibleFile, setVisibleFile] = useState(false);
  const [disable, setDisable] = useState(false);
  const [started, setStarted] = useState(false);
  const [money, setMoney] = useState(0)

  const {
    totalHHMMSS,
  } = useTaskTime(timers, { intervalMs: 1000 });
  const handleStart = async (ev) => {
    if (ev) {
      await Api.startAgentTaskTimer({
        "task": id,
      })

    } else {
      await Api.stopAgentTaskTimer(single?.timers[0].id)
    }
    await handleFetch()
    await dispatch(agentTimer())
    setStarted(ev)

  }

  const handleFetch = async () => {
    const { data } = await Api.getAgentTaskSingle(id)
    setSingle(data)
    setTimers(data.timers || [])
    if (data.timers.length && !data.timers[0].stopped_at) {
      setStarted(true)
    }
  }
  const handleMoney = async (ev) => {
      try {
        ev.preventDefault()
        await Api.agentPurchaseAdd({
          "task_id": +id,
          "agent_id": profession === "agent"?login.id:null,
          "company_id": profession === "agent"?null:single.company?.id,
          "item_name": "Task",
          "amount": money
        })
        await handleFetch()
        SuccessToast()
      } catch (error) {
        
      }
  }
  const [visibleMessage, setVisibleMessage] = useState(false);

  const hamdleEnd = async () => {
    if (!single?.timers[0].stopped_at) {
      await Api.stopAgentTaskTimer(single?.timers[0].id)
    }
    await dispatch(agentTimer())
    setStarted(false)
    await Api.endAgentTaskTimer(single?.id)
    await handleFetch()
  }
  const navigate = useNavigate()
  useEffect(() => {
    (async () => {
      await handleFetch()
    })()
  }, [id,])
  useEffect(() => {
    (async () => {
      try {
        if (id && location.search) {
          localStorage.setItem("in_view", location.pathname)
        }
      } catch (error) {

      }
    })()
  }, [location.search, id])

  const handleAction = async (type, pid, sender) => {
    try {
      setDisable(true)
      await Api.agentPurchase(pid, { status: type, sender })
      await handleFetch()
      setDisable(false)
      SuccessToast()

    } catch (error) {
      setDisable(true)
    }
  }



  return (
    <Wrapper>
      {!single ? <div className="transparent-loader">
        <Loader size={15} />
      </div> :
        <Row className='justify-content-between w-100'>

          <Col xs={12} sm={8}>
            <a onClick={() => navigate(-1)} className="link-Backward-arrow">
              <span className="icon-Backward-arrow" />
            </a>
            <div className="employee-name-button" style={{ width: "max-content" }}>
              <div className="employee-name">
                <span>
                  {single.assigned_to?.user?.first_name} {single.assigned_to?.user?.last_name}
                </span>
              </div>
              <div className="timePicker-cont-change">
                <div className="timePicker-cont">
                  <TextField
                    id="datetime-local"
                    label="Վերջնաժամկետ"
                    type="datetime-local"
                    disabled
                    onChange={single?.status !== "end" ? (e) => {
                      setForm(prev => ({ ...prev, due_date: e.target.value }));
                      setShowPicker(true)
                    } : () => {
                    }}
                    value={single?.due_date || ""}
                    InputProps={{ inputProps: { min: moment(new Date()).format("YYYY-MM-DDTHH:mm") }, }}
                    sx={{ width: 250 }}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>

                {/* <div className="icons-copy-edit">
                  <div className="tool-tip-cont">
                    <div className="tool-tip">Պատճենել</div>
                    <i className="fas fa-copy" onClick={() => setCopy(true)} />
                  </div>
                </div> */}
              </div>
            </div>
            {/* Show timer only if task type is NOT 5 and NOT 3 */}
            {single.task_type?.id !== 5 && single.task_type?.id !== 3 && (
              <div className="timer">
                <span style={{ marginBottom: 20 }}> Ժամանակ - {totalHHMMSS}</span>
                {single.status === "completed" ? null : profession === "agent" && single?.assigned_to?.id === login?.id ? !single?.timers?.length ? <BlueButton title="Սկսել" onChangeValue={() => handleStart(true)} /> : <BlueButton title="Ավարտել" onChangeValue={() => hamdleEnd(false)} /> : null}
                {single.status === "completed" ? null : profession === "agent" ? single?.assigned_to?.id === login?.id && single.timers.length ? started ? <LittleButton title="Դադար" onChangeValue={() => handleStart(false)} /> : <LittleButton title="Սկսել" onChangeValue={() => handleStart(true)} /> : null : null}
              </div>
            )}
            
            {/* Show Google Meet link for task type 5 */}
            {single.task_type?.id === 5 && (
              <div className="google-meet-section" style={{ margin: '20px 0' }}>
                <h4 style={{ marginBottom: '10px' }}>Google Meet հրավեր</h4>
                {single.google_meet_link ? (
                  <a 
                    href={single.google_meet_link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      padding: '10px 20px',
                      backgroundColor: '#4285f4',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '4px',
                      fontWeight: '500'
                    }}
                  >
                    🎥 Միացել հանդիպմանը
                  </a>
                ) : (
                  <div style={{ 
                    padding: '10px', 
                    backgroundColor: '#fff3cd', 
                    border: '1px solid #ffc107',
                    borderRadius: '4px',
                    color: '#856404'
                  }}>
                    ⚠️ Google Meet հղումը դեռ չի ստեղծվել։ Խնդրում ենք կապվել ադմինիստրատորի հետ։
                  </div>
                )}
              </div>
            )}
            <Link to={`/main_employee/organization/${single?.company?.id}`} className="company-name">
              {single?.company?.name || ""}
            </Link>
            <div className="task-heading-file">
              <h2>{single?.title}</h2>
            </div>
            <p>{single?.description}</p>
            
            {/* Show rejection info and resubmit button for rejected tasks */}
            {single.status === "rejected" && (
              <div style={{ 
                margin: '20px 0',
                padding: '15px',
                backgroundColor: '#f8d7da',
                border: '1px solid #f5c2c7',
                borderRadius: '4px',
                color: '#842029'
              }}>
                <h4 style={{ marginBottom: '10px' }}>❌ Առաջադրանքը մերժված է</h4>
                {single.rejection_reason && (
                  <p style={{ marginBottom: '10px' }}>
                    <strong>Պատճառ:</strong> {single.rejection_reason}
                  </p>
                )}
                {single.rejected_at && (
                  <p style={{ marginBottom: '15px', fontSize: '14px' }}>
                    <strong>Մերժված է:</strong> {moment(single.rejected_at).format('LLL')}
                  </p>
                )}
                {profession === "agent" && single?.assigned_to?.id === login?.id && (
                  <BlueButton 
                    title="Ավարտել և ուղարկել վերադիտարկման" 
                    onChangeValue={hamdleEnd}
                    buttonStyle="blue-button"
                  />
                )}
              </div>
            )}
            
            <div>
              {single?.end_date && <p className="end-date">{word.end_date}՝</p>}
              <p className="end-date">
                {single?.end_date ? moment(single?.end_date).format("LLL") : ""}
              </p>
            </div>

            <div className='line-blue' />
            {single.task_type?.id === 2 || single.task_type?.id === 4 ?
              <div>
                <h4>{single.task_type?.name}</h4>
                <div>
                  {single.purchases?.length ?
                    <div className='d-flex flex-column'>
                      {single.purchases?.map(l => {
                        let visible = l.agent?.user?.id === login?.user?.id
                        return (<div className={visible? 'd-flex align-items-center justify-content-end' : 'd-flex align-items-center'}>
                          <div className={visible ? 'agentMine' : 'agentOther'} >
                            <p className="m-0" style={{ color: l.status === 0 ? "red" : l.status === 1 ? "green" : "#6e6e6e", fontSize: 14 }}>{+l.amount}</p>
                            <p className="m-0" style={{ color: l.status === 0 ? "red" : l.status === 1 ? "green" : "#9e9e9e", fontSize: 10 }}>{new Date(l.purchase_date).toLocaleString()}</p>
                            <p className="m-0" style={{ color: l.status === 0 ? "red" : l.status === 1 ? "green" : "#9e9e9e", fontSize: 10 }}>{l.agent?.user?.first_name || l.client?.user?.first_name} {l.agent?.user?.last_name || l.client?.user?.last_name}</p>
                          </div>
                          {((profession!== "agent" && single?.creator?.id === login.user_id && !l.client) || profession === "agent" && !visible) && !single?.assigned_to? <div style={{ marginLeft: 10 }}>
                            <span className='accept' onClick={() => disable ? null : handleAction(1, l.id, profession === "agent"?"agent":"client")}>
                              Հաստատել
                            </span>
                            <span className='reject' onClick={() => disable ? null : handleAction(0, l.id,profession === "agent"?"agent":"client")} style={{ marginLeft: 10 }}>
                              Մերժել
                            </span>
                          </div> : null}
                        </div>)
                      }
                      )}
                    </div> : "Դեռ գնային առաջարկ չի կատարվել"}
                  {single.assigned_to?.id  ? null:<div>
                    <form onSubmit={handleMoney}>
                    <input type="number" value={money} className='agentInput' onChange={(ev) => setMoney(ev.target.value)} />

                    </form>
                  </div>}
                </div>
              </div>
              : null}
            <div className='line-blue' />
            <span className="message-heading">{word.message}</span>

            <div className="icon-button-cont">
              <AgentFiles visibleFile={visibleFile} setVisibleFile={setVisibleFile} />
              <AgentComment visibleMessage={visibleMessage} setVisibleMessage={setVisibleMessage} />

            </div>
            <MessageInput visibleMessage={visibleMessage} form={single} />

            <FileUpload task={single} open={visibleFile} setOpen={setVisibleFile} />
          </Col>

          {/* <Col xs={12} sm={3}>
            <TaskLine form={form} />
          </Col> */}
        </Row>}

    </Wrapper>
  )
}
